import React from 'react';
import ReactDOMServer from 'react-dom/server';

import bootbox from "bootbox";

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues } from "../../redux/actions";
import { partsListSelector } from "../../redux/selectors";

import CartiReplacements from '../CartiReplacements/CartiReplacements';
import TooltipCart from '../views/TooltipCart';
import BaseClass from '../common/baseClass';
import { in_WishList } from '../views/WishList';

const common = require('../common/common');
const cart = require('../common/cart');
const env = require("../../config.js").default;

class PartsList extends BaseClass {
	constructor(props){
		super(props);
		this.apriVariantePrima = this.apriVariantePrima.bind(this);
		this.state = { listinoVM: false, sosti: [], arti: [], cartiRepLoader: false, showReplacements: false, showTooltipCarti: false };
	}
	
	componentWillMount(){
		this.updateStateWithStoreProps();
		
		if(this.state.renewMutex.distinta && this.state.filtersState.marca && this.state.filtersState.modello && this.state.filtersState.tavola){
			this.props.changeMutex("distinta", false);
			
			common.isEnabledList(this.state.filtersState.marca).then((list) => {
				this.setState({ listinoVM: list });
			})

			this.getPartsData();
		}
	}

	componentDidMount() {
		const $ = window.$;
		var th = $('.tabellaDistinta').find('tr.tabellaDistintaHead')
		$('.tabellaDistinta').on('scroll', function() {
			th.css('transform', 'translateY('+ this.scrollTop +'px)');
		});
		this.setState({rerender: Math.random()});
	}

	componentWillReceiveProps(nextprops){
		this.updateStateWithStoreProps(nextprops);
		this.setState({rerender: Math.random()});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const $ = window.$;
		this.updateStateWithStoreProps();
		this.apriVariantePrima("componentDidUpdate", prevProps);
		if (prevProps.store.filtersState.tavola !== this.state.filtersState.tavola) {
			this.props.changeMutex("distinta", false);

			common.isEnabledList(this.state.filtersState.marca).then((list) => {
				this.setState({ listinoVM: list });
			})

			this.getPartsData();
			$('.tabellaDistinta').scrollTop(0);
		}
	}

	scrollToTarget = () => {
		const $ = window.$;
		if (this.state.filtersState.applicazione) {
			$('.tabellaDistinta').animate({ scrollTop: $(".target").offset().top - $(".tabellaDistinta").offset().top - ($(".tabellaDistinta").height() / 2) }, 900);
		}
	}

	getPartsData = () => {
		const $ = window.$;
		const enabledList = common.getAppEnabledList();
		const cswln = enabledList[this.state.filtersState.marca] || '';
		
		if (this.state.filtersState.marca && this.state.filtersState.modello && this.state.filtersState.tavola) {
			var data = { zprod: this.state.filtersState.marca, cmoto: this.state.filtersState.modello, ctavo: this.state.filtersState.tavola, cswln: cswln };
			common.apiCall(env.BACKEND + "epc/get_draw_parts/", "GET", data, true, false, 'json', env.RECAPTCHA_VERIFY).then((distinta) => {
				if (distinta.error === false) {
					// ordino i numeri di riferimento per fare in modo che siano sempre vicini se ci sono varianti
					function compareNumbers(a, b) {
						if ((a.NRIPE - b.NRIPE) === 0)
							if (a.TYPE === "GenericV")
								return -1
							else if (b.TYPE === "GenericV")
								return 1
						
						return a.NRIPE - b.NRIPE;
					}
					distinta = distinta.sort(compareNumbers);
					
					this.props.changeValues({ renewMutex: { distinta: true }, dataList: { distinta: distinta } });
				} else {
					$(".banner_center_header>a").click();
					return false;
				}
			});
		}
	}

	addArticolo(articolo, articoloKey, wishListIndex){
		var dataList = this.state.dataList;
		var wishList = dataList.wishList;
		var action = "add_to_cart";

		if(wishListIndex === -1)
			wishList.push(articolo);
		else{
			wishList[wishListIndex].qpezzi = parseInt(articolo.qpezzi);
			action = "update_cart";
		}

		common.set_localStorage("wishList", JSON.stringify(wishList));
		this.props.changeDatalist("wishList", wishList);

		if(cart.isCartByFrameMessage()){
			cart.saveCheckout([articolo]);
			let arti_for_post = {
				"zfornwrd": articolo.marca,
				"cartiwrd": articolo.carti,
				"drigawrd": articolo.darti,
				"qmoviwrd": articolo.qpezzi,
				"cvaluwrd": articolo.cvalu,
				"lricawrd": articolo.price,
			}
			window.parent.postMessage({ action: action, items: [arti_for_post] }, '*');
		}
		this.setState({ showTooltipCarti: true });
	}

	removeArticolo(articolo){
		var dataList = this.state.dataList;
		var wishList = dataList.wishList;

		var artPos = in_WishList({CARTI: articolo});

		if(cart.isCartByFrameMessage()){
			let item = wishList[artPos];
			item.qpezzi = 0;
			cart.saveCheckout([item]);
			let arti_for_post = {
				"zfornwrd": item.marca,
				"cartiwrd": item.carti,
				"drigawrd": item.darti,
				"qmoviwrd": item.qpezzi,
				"cvaluwrd": item.cvalu,
				"lricawrd": item.price,
			}
			window.parent.postMessage({ action: "remove_cart", items: [arti_for_post] }, '*');
		}

		if(artPos > -1){
			this.state.dataList.wishList.splice(artPos,1);
			common.set_localStorage("wishList", JSON.stringify(this.state.dataList.wishList));
			this.props.changeDatalist("wishList", this.state.dataList.wishList);
		}
	}

	calcElementsHeight() {
		// --- FIX INTEGRAZIONE SOFTWAY: EVITA IL LOOP INFINITO ---
		if (window.parent !== window) {
			const $ = window.$;
			if ($ && $("#distintaTableContainer").length > 0) {
				// Sblocchiamo le altezze: la tabella prende tutto lo spazio che le serve
				$("#distintaTableContainer").css("max-height", "none");
				$(".tabellaDistinta").css("max-height", "none");
			}
			// Usciamo dalla funzione: non eseguiamo il calcolo basato su window.innerHeight
			return; 
		}
		// --------------------------------------------------------

		const $ = window.$;
		if($("#distintaTableContainer") !== undefined && $("#distintaTableContainer").length > 0){
			var containerHeight = window.innerHeight - $("#distintaTableContainer").offset().top - 15;
			
			if(containerHeight < 380)
				containerHeight = 380;
			var contentHeight = window.innerHeight - $(".tabellaDistinta").offset().top - 15;
			if(contentHeight < 300)
				contentHeight = 300;

			if(contentHeight >= containerHeight){
				contentHeight = containerHeight - 80;
			}
			$("#distintaTableContainer").css("max-height", containerHeight);
			$(".tabellaDistinta").css("max-height", contentHeight);
		}
	}

	shouldComponentUpdate(nextProps, nextState){
		return super.shouldComponentUpdate(nextProps, nextState);
	}

	handleEditWishlistClick = (articolo, articoloKey) => {
		const $ = window.$;
		var wishListIndex = in_WishList(articolo)
		let stateFilter = this.state.filtersState;
		this.closeTooltipCart();
		this.setState({ arti: common.cloneFromState(articolo) });
		if (articolo.TMOVI === "S") {
			this.setState({ cartiRepLoader: true, artiIndex: articoloKey });
			let cswln = window.cc.enabledList[stateFilter.marca];
			let params = { zprod: stateFilter.marca, cmoto: stateFilter.modello, ctavo: stateFilter.tavola, carti: articolo.CARTI, nripe: articolo.NRIPE, cswln: cswln ? cswln : false};
			common.apiCall(env.BACKEND + "epc/get_replacements/", "GET", params, true, false, 'json', env.RECAPTCHA_VERIFY).then((data) => {
				if (data.error !== true) {
					let arti = common.cloneFromState(articolo)
					arti.ISPADRE = true;
					data.unshift(arti);
					this.setState({ 
						sosti: data,
						arti: arti,
						cartiRepLoader: false, 
						showReplacements: true 
					});
				}
			})
		}
		else {
			bootbox.dialog({
				locale: common.getLanguage(),
				onEscape: function () { },
				title: (wishListIndex > -1 ? common.getTrad("Modifica la quantità dell'articolo nella Wish List") : common.getTrad("Aggiungi l'articolo nella Wish List")),
				message:
					"<div class='displayArti'>"
					+ ("<b>" + common.getTrad("Codice Articolo") + "</b>: " + articolo.CARTI)
					+ "<br/>"
					+ "</div>"
					+ "<b>" + common.getTrad("Descrizione") + "</b>: " + (articolo.DARTI ? articolo.DARTI : articolo.DART2)
					+ "<br/>"
					+ (articolo.DVARI !== undefined && articolo.DVARI !== null && articolo.DVARI !== '' ?
							 ReactDOMServer.renderToStaticMarkup(<p dangerouslySetInnerHTML={{ __html:(articolo.DVARI).replace(/\r?\n/g,'<br/>')}}/>)
					:
						"<br/>")
				+ "<div class=\"input-group\">"
				+ "<div class=\"input-group-prepend\">"
				+ "<span class=\"input-group-text\">" + (wishListIndex > -1 ? common.getTrad("Quantità nel carrello") : common.getTrad("Quantità")) + "</span>"
				+ "</div>"
				+ "<input class=\"form-control numArticoloCarello\" type=\"number\" min=\"1\" max=\"9999\" value=" + (wishListIndex > -1 ? parseInt(this.state.dataList.wishList[wishListIndex].qpezzi) : parseInt(articolo.QPEZZ)) + " />"
				+ "</div>"
				+ "<div class=\"mt-2 alert alert-warning\" id=\"addArticoloError\" role=\"alert\" style=\"display:none\"></div>",
				buttons: {
					remove: {
						label: common.getTrad("Rimuovi"),
						className: 'btn-danger ' + (wishListIndex > -1 ? "d-block" : "d-none"),
						callback: () => {
							this.removeArticolo(articolo.CARTI)
						}
					},
					annulla: {
						label: common.getTrad("Annulla"),
						className: 'btn-light',
						callback: () => {
							bootbox.hideAll();
							return false;
						}
					},
					add: {
						label: (wishListIndex > -1 ? common.getTrad("Salva") : common.getTrad("Aggiungi")),
						className: 'btn bottone_default',
						callback: () => {
							const $ = window.$;
							var result = $(".numArticoloCarello").val();
							if (!result || !result.match(/^[0-9]+$/)){
								$("#addArticoloError").html(common.getTrad("Non sono ammessi valori non numerici"));
								$("#addArticoloError").show();
								return false;
							}
							if(result > 9999){
								$("#addArticoloError").html(common.getTrad("Non sono ammessi valori maggiori di 9999"));
								$("#addArticoloError").show();
								return false;
							}
							if (result < 1) {
								$("#addArticoloError").html(common.getTrad("Non sono ammessi valori inferiori a 1"));
								$("#addArticoloError").show();
								return false;
							}
							$("#addArticoloError").hide();
							this.addArticolo({
								carti: articolo.CARTI,
								cartiSost: articolo.hasOwnProperty("cartiSost") ? articolo.cartiSost : null,
								darti: articolo.DARTI,
								dart2: articolo.DART2,
								dvari: articolo.DVARI,
								marca: this.state.filtersState.marca,
								qpezzi: result,
								modello: this.state.filtersState.modello,
								tavola: this.state.filtersState.tavola,
								price: articolo.PRICE,
								cvalu: articolo.CVALU,
							}, articoloKey, wishListIndex);
						}
					}
				},
			});
		}
	}

	closeTooltipCart = () => {
		this.setState({
			showTooltipCarti: false
		});
	}

	closeReplacement = () => {
		this.setState({
			showReplacements: false
		});
	}

	apriVariantePrima(dove, prevProps) {
		const $ = window.$;
		for(var i = 0; i<this.state.dataList.distinta.length; i++){
			if(this.state.filtersState.applicazione && this.state.filtersState.applicazione === this.state.dataList.distinta[i].CARTI){

				var nripe = this.state.dataList.distinta[i].NRIPE.replace(/\s/g,'');
				$(".tabellaDistinta tbody tr").each((i, elem) => {
					if($(elem).hasClass("gruppo_varianti")){
						$(".variante_" + nripe + " .singola_variante span.variante_" + nripe).click();
						var variante = $(".variante_" + nripe + " .singola_variante span.variante_" + nripe);
						if(variante[0] !== undefined && variante[0] !== null){
							if(variante[0].classList !== undefined && variante[0].classList !== null && variante[0].classList !== ''){
								this.apriVariante(variante[0].classList, true);
								return false;
							}
						}
						return false;
					}
				});
				//this.scrollToTarget();
			}
		}
	}

	apriVariante(e, applicazione){
		const $ = window.$;
		var classVariante = "", classList = [];
		if(!applicazione){
			classList = e.currentTarget.classList;
		}else {
			classList = e;
		}

		classList.forEach((el) => {
			if(el.indexOf("variante_") > -1)
				classVariante = el;
		});

		if(!applicazione){
			$('.' + classVariante).toggleClass("mostra_varianti");
		}else{
			$('.' + classVariante).addClass("mostra_varianti");
		}
	}

	render(){
		const $ = window.$;
		const localeLang = common.getLanguageLocale();
		var wishList = '';
		if(common.get_localStorage("wishList") && common.get_localStorage("wishList") !== "" && common.get_localStorage("wishList") !== undefined && common.get_localStorage("wishList") !== null){
			wishList = JSON.parse(common.get_localStorage("wishList"));
		}else{
			wishList = [];
			common.set_localStorage("wishList", JSON.stringify(wishList));
		}

		$(window).ready(() => { this.calcElementsHeight(); });
		$(window).resize(() => { this.calcElementsHeight(); });
		var variantiStampate = [];
		return(
			<div className="col-xl-6 col-sm-12" id="distintaTableContainer">
				<style id='tabellaDistintaBeforeTitle'>{ `
					.tabellaDistinta td:nth-of-type(1):before {display: none }
					.tabellaDistinta td:nth-of-type(2):before {content: "` + common.getTrad("Rif.") + `"; }
					.tabellaDistinta td:nth-of-type(3):before {content: "` + common.getTrad("Codice Articolo") + `"; }
					.tabellaDistinta td:nth-of-type(4):before {content: "` + common.getTrad("Descrizione") + `"; }
					.tabellaDistinta td:nth-of-type(5):before {content: "` + common.getTrad("Pezzi") + `";}
					` +
					(this.state.listinoVM ?
					`.tabellaDistinta td:nth-of-type(6):before {content: "` + common.getTrad("Prezzo") + `";}
					.tabellaDistinta td:nth-of-type(7):before {display: none }`
					:
					`.tabellaDistinta td:nth-of-type(6):before {display: none }`
					) 
				}</style>
				<h3 id="titleDistinta">{common.getTrad("Elenco Pezzi")}</h3>
				<table className="tabellaDistinta table table-responsive table-striped">
					<tbody>
						<tr className="tabellaDistintaHead">
							<th></th>
							<th>{common.getTrad("Rif.")}</th>
							<th className='displayArti'>{common.getTrad("Codice Articolo")}</th>
							<th>{common.getTrad("Descrizione")}</th>
							<th>{common.getTrad("Pezzi")}</th>
							{this.state.listinoVM && (
								<th className="gridPrice">{common.getTrad("Prezzo")}</th>
							)}
							<th></th>
						</tr>
						{this.state.dataList && this.state.dataList.distinta ?
							Object.keys(this.state.dataList.distinta).map((index, key) => {
								if (index !== "error") {
									var classe = "";
									var classeTD = "", classeTD2 = "";
									var classeArti = "";
									var primaVaraiante = false;
									var wishListIndex = in_WishList(this.state.dataList.distinta[index]);
									var valuta = this.state.dataList.distinta[index].CVALU;
									var prezzo = this.state.dataList.distinta[index].PRICE;
									var non_ordinabile = false
									if (this.state.listinoVM) {
										non_ordinabile = ((this.state.dataList.distinta[index].FAGGI == "C" || this.state.dataList.distinta[index].FAGGI == null) && this.state.dataList.distinta[index].TMOVI != "S")
									}
									
									//Calcolo classi righe tabella
									if (this.state.dataList.distinta[index].TYPE === 'V' || this.state.dataList.distinta[index].TYPE === 'GenericV'){
										classe = "gruppo_varianti variante_" + (this.state.dataList.distinta[index].NRIPE).replace(/\s/g,'');
										classeTD = "singola_variante";
										if(variantiStampate.indexOf(this.state.dataList.distinta[index].NRIPE) <= -1){
											classe = classe + " prima";
											primaVaraiante = true;
											variantiStampate.push(this.state.dataList.distinta[index].NRIPE);
										}
										if (this.state.dataList.distinta[index].TYPE === 'GenericV')
											classeTD += " genericVariantTD"
									}
									if (this.state.filtersState.applicazione && this.state.filtersState.applicazione === this.state.dataList.distinta[index].CARTI) {
										classeArti = "highlight";
										classe = classe + " target";
									}
									classeTD2 = classeTD;
									if (non_ordinabile) {
										classeTD += " non_ordinabile";
									}
									
									const td_cart = (
										(non_ordinabile || this.state.dataList.distinta[index].TYPE === "GenericV") ? (
											<td className={classeTD}></td>
										) : (
											<td style={{ cursor: "pointer" }} className={("animated articoloRow_" + key) + " " + classeTD + " buttonAddArticoloCarrello colonnaAzioniRigaTabellaDX "} onClick={(e) => {
												e.stopPropagation();
												this.handleEditWishlistClick(this.state.dataList.distinta[index], index)
											}
											}>
												<span>
													<i className="fas fa-cart-plus"></i>
													<sup style={{ visibility: (wishListIndex > -1 ? "visible" : "hidden") }}>
														<i className="fas fa-check-circle justWished"></i>
													</sup>
												</span>
											</td>
										)
									)

									const td_price = () => {
										if (this.state.listinoVM) {
											if (this.state.dataList.distinta[index].TYPE === 'GenericV') {
												return (<td className={classeTD + ' gridPrice'}></td>)
											}
											else {
												return (<td className={classeTD + ' gridPrice'}>{prezzo.toLocaleString(localeLang, { style: 'currency', currency: valuta })}</td>)
											}
										}
										return null;
									}
	

									if (this.state.dataList.distinta[index] !== false)
										return(
											<tr key={key} className={classe} onClick={(e) => {if(primaVaraiante) this.apriVariante(e, false)}}>
												<td className={classeTD2}><span className={"fas varianteButton desktopVarianteButton variante_" + this.state.dataList.distinta[index].NRIPE.replace(/\s/g,'')}></span></td>
												<td className={classeTD}>{this.state.dataList.distinta[index].NRIPE.replace(/\s/g,'')} <span className={"fas varianteButton responsiveVarianteButton variante_" + this.state.dataList.distinta[index].NRIPE.replace(/\s/g,'')}></span></td>
												<td className={classeTD + ' displayArti'}>
													{this.state.filtersState.applicazione && this.state.filtersState.applicazione === this.state.dataList.distinta[index].CARTI ?
														<span className="highlight">{this.state.dataList.distinta[index].CARTI}</span>
													:
														this.state.dataList.distinta[index].CARTI
													}
												</td>
												<td className={classeTD}>{this.state.dataList.distinta[index].DARTI ? <span className={classeArti}>{this.state.dataList.distinta[index].DARTI}</span> : <span className={classeArti}>{this.state.dataList.distinta[index].DART2}</span>}
													{this.state.dataList.distinta[index].DVARI !== undefined && this.state.dataList.distinta[index].DVARI !== null && this.state.dataList.distinta[index].DVARI !== '' ?
														<p dangerouslySetInnerHTML={{ __html:(this.state.dataList.distinta[index].DVARI).replace(/\r?\n/g,'<br/>')}}/>
													:
														""
													}
													{this.state.dataList.distinta[index].TYPE === 'GenericV' && (
														<>
															<br />
															<small className='genericVariant'>{common.getTrad("Clicca per varianti")}</small>
														</>
													)}
												</td>
												<td className={classeTD}>{this.state.dataList.distinta[index].QPEZZ}</td>
												{td_price()}
												{this.state.cartiRepLoader && this.state.artiIndex == index ? (
													<td className={classeTD + ' colonnaAzioniRigaTabellaDX'}>
														<span>
														<i className='fas fa-spinner fa-spin'></i>
														<sup style={{ visibility: 'hidden' }}>
															<i className="fas fa-check-circle justWished"></i>
														</sup>
														</span>
													</td>
												)
													:
												(
													td_cart
												)}
												
											</tr>
										)
									else
										return false;
								}
								})
							:
								""
						}
					</tbody>
				</table>
				{this.state.showReplacements && <CartiReplacements handleEditWishlistClick={this.handleEditWishlistClick} data={this.state.sosti} articolo={this.state.arti} handleCloseReplacement={this.closeReplacement} />}
				{this.state.showTooltipCarti && <TooltipCart handleClose={this.closeTooltipCart} articolo={this.state.arti}/>}
			</div>
		);
	}
}

const mapStateToProps = state => {
	const store = partsListSelector(state);
	return { store };
}
export default connect(mapStateToProps, { changeFilter, changeDatalist, changeMutex, changeValues })(PartsList);
